var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("yxt-date-picker", {
        staticClass: "width-full",
        attrs: {
          disabled: _vm.disabled,
          editable: false,
          type: _vm.timeType[_vm.category],
          format: _vm.timeFormat[_vm.category],
          "value-format": _vm.timeFormat[_vm.category],
          clearable: "",
        },
        on: { change: _vm.changeDate },
        model: {
          value: _vm.date,
          callback: function ($$v) {
            _vm.date = $$v
          },
          expression: "date",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }